import routerOptions0 from "/home/runner/_work/monorepo/monorepo/frontend/marketplace/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  linkActiveClass: "",
  linkExactActiveClass: "",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}